import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import R from '../../../core-res/R';
import DRNText from '../../../standard/Text/DRNText';
class CounterText extends PureComponent {
    render() {
        const { count, limit, restricted, disabled, theme } = this.props;
        if (!limit) {
            return null;
        }
        let textColor = theme.textSecondary;
        if (restricted) {
            textColor = theme.textAlert;
        }
        else if (disabled) {
            textColor = theme.textMuted;
        }
        return (<View style={styles.container}>
        <DRNText style={[styles.text, { color: textColor }]}>{`${count} / ${limit}`}</DRNText>
      </View>);
    }
}
CounterText.propTypes = {
    count: PropTypes.number.isRequired,
    limit: PropTypes.string,
    restricted: PropTypes.bool,
    disabled: PropTypes.bool,
    theme: PropTypes.object,
};
const styles = StyleSheet.create({
    container: {
        paddingLeft: R.spacing.xxs,
        paddingBottom: R.spacing.xs,
    },
    text: Object.assign({}, R.typography.uiTiny, { textAlign: 'right' }),
});
export default CounterText;
